import Axios from '../common/http.js';

/**
 * 登录接口
 */
export const login = (data) => {
	return Axios.post('/gorc/admin/login', data);
};


/**
 * 上传文件
 */
export const upload = (data) => {
	return Axios.post('/gorc/admin/upload', data);
};


/**
 * 获取t'o'k'e'n
 */
export const getToken = (params) => {
	return Axios.get('/gorc/admin/account/token/generate', {params});
};


